<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">商品中心</el-breadcrumb-item>
      <el-breadcrumb-item>分类管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">
          <el-form-item label="分类名称" prop="name">
            <el-input size="small" style="width: 200px;" v-model="formInline.name" placeholder="请输入标题"></el-input>
          </el-form-item>

          <el-form-item label="所属大类" prop="type">
            <el-select v-model="formInline.type" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                v-for="item in typeSelect"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="请选择状态" prop="status">
            <el-select v-model="formInline.status" placeholder="请选择状态">
              <el-option label="开启中" :value = 0></el-option>
              <el-option label="已禁用" :value = 1 ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList" >搜索</el-button>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
          </el-form-item>
        </el-form>


        <!--列表-->
        <el-tabs v-model="editableTabsValue" type="card" style="margin-bottom: 20px;margin-left: 50px"
                 @tab-click="tablesListByExhId">
          <el-tab-pane
            v-for="(item, index) in exhList"
            :key="item.id"
            :label="item.exhibitionName"
            :name="item.id">

            <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                      highlight-current-row v-loading="loading" border
                      element-loading-text="拼命加载中" style="width: 100%;">

              <el-table-column prop="name" label="分类名称" align="center"></el-table-column>

              <el-table-column prop="icon" label="分类icon" align="center">
                <template slot-scope="scope">
                  <el-popover placement="top-start" trigger="hover">
                    <a :href="scope.row.icon" target="_blank" title="查看最大化图片"><img :src="scope.row.icon" style="width: 300px;height: 300px" /></a>
                    <img slot="reference" :src="scope.row.icon" style="width: 50px;height: 50px; cursor:pointer" />
                  </el-popover>
                </template>
              </el-table-column>

              <el-table-column prop="type" label="所属大类" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.type==1">服务类</el-tag>
                  <el-tag type="danger" v-if="scope.row.type==2">工程类</el-tag>
                  <el-tag type="info" v-if="scope.row.type==3">餐饮类</el-tag>
                  <el-tag v-if="scope.row.type==4">租赁类</el-tag>
                </template>
              </el-table-column>

              <el-table-column prop="sort" label="分类排序" align="center"></el-table-column>

              <el-table-column align="center"  prop="status" label="状态" width="170px" >
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.status"
                    active-text="启用"
                    inactive-text="禁用"
                    :active-value="0"
                    :inactive-value="1"
                    @change="turn(scope.row)">
                  </el-switch>
                </template>
              </el-table-column>

              <el-table-column align="center"  prop="createTime" label="创建时间" >
                <template slot-scope="scope">
                  <div>{{scope.row.createTime|timestampToTime}}</div>
                </template>
              </el-table-column>

              <el-table-column  label="操作" align="left" fixed="right">
                <template slot-scope="scope">
                  <el-button size="mini" type="warning" @click="handleEdit(scope.$index, scope.row)"style="width: 100px;margin: 1px;">编辑</el-button>
                </template>
              </el-table-column>

            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

          </el-tab-pane>
        </el-tabs>




        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="35%" @click='closeDialog("edit")':close-on-click-modal="false">
          <el-form label-width="120px" :model="editForm" ref="editForm"  :rules="rules">
            <el-form-item label="分类名称" prop="name">
              <el-input size="small" v-model="editForm.name"  :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" placeholder="请输入分类名称"></el-input>
            </el-form-item>


            <el-form-item label="分类icon" prop="icon">
              <div class="iconlist">
                <div id="upClass1" class="imgdiv" @click="upClass1('https://img.flyh5.cn/java/image/1685697004779.png')"><img src="../../assets/img/1.png" class="img"></div>
                <div id="upClass2" class="imgdiv" @click="upClass2('https://img.flyh5.cn/java/image/1685697034031.png')"><img src="../../assets/img/2.png" class="img"></div>
                <div id="upClass3" class="imgdiv" @click="upClass3('https://img.flyh5.cn/java/image/1685697047700.png')"><img src="../../assets/img/3.png" class="img"></div>
                <el-col/>
                <div id="upClass4" class="imgdiv" @click="upClass4('https://img.flyh5.cn/java/image/1685697063905.png')"><img src="../../assets/img/4.png" class="img"></div>
                <div id="upClass5" class="imgdiv" @click="upClass5('https://img.flyh5.cn/java/image/1685697075239.png')"><img src="../../assets/img/5.png" class="img"></div>
                <div id="upClass6" class="imgdiv" @click="upClass6('https://img.flyh5.cn/java/image/1685697084782.png')"><img src="../../assets/img/6.png" class="img"></div>
                <el-col/>
                <div id="upClass7" class="imgdiv" @click="upClass7('https://img.flyh5.cn/java/image/1685697095887.png')"><img src="../../assets/img/7.png" class="img"></div>
                <div id="upClass8" class="imgdiv" @click="upClass8('https://img.flyh5.cn/java/image/1685697107327.png')"><img src="../../assets/img/8.png" class="img"></div>
                <div id="upClass9" class="imgdiv" @click="upClass9('https://img.flyh5.cn/java/image/1686274926230.png')"><img src="../../assets/img/9.png" class="img"></div>

                <el-col>
                  <div class="imgdiv">
                    <el-upload
                      class="avatar-uploader"
                      :action="this.host+'/fileUpload/ossBatch'"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccessImage"
                      :before-upload="beforeAvatarUpload">
                      <img v-if="editForm.icon" :src="editForm.icon" class="avatar" width="60" style="margin-top: 13px">
                      <div v-else class="text"><h3>自定义</h3></div>
                    </el-upload>
                  </div>
                </el-col>
              </div>
              <div class="tiphint">建议上传尺寸 120 * 120</div>

            </el-form-item>

            <el-form-item label="所属大类" prop="exhibitionId">
              <el-select v-model="editForm.type" placeholder="请选择"  style="height: 33px;width: 250px;">
                <el-option
                  v-for="item in typeSelect"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="所属展会" prop="exhibitionId">
              <el-select v-model="editForm.exhibitionId" placeholder="请选择">
                <el-option
                  v-for="item in exhList"
                  :key="item.id"
                  :label="item.exhibitionName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
              <el-input type="number"  v-model="editForm.sort" ></el-input>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title" :loading="loading" :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>


      </el-main>
    </el-container>
  </div>
</template>

<script>



import {qryCommodityList,upCommodityStatus,upCommodity,addCommodity} from '../../api/lotteryApi'
import {qryExhibitionList} from '../../api/courseApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";


export default {
  name: "playgroundList",
  data() {
    return {
      title:'添加',
      editFormVisible:false,
      loading: false, //是显示加载
      isDisabled: false,
      editableTabsValue: null,
      formInline:{
        name:'',
        type:'',
        exhibitionId:'',
        status:'',
        page:1,
        pageSize:10
      },
      listData:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      baseForm: '',
      editForm:{
        id:'',
        name:'',
        icon:'',
        type:'',
        exhibitionId:'',
        sort:''
      },
      // rules表单验证
      rules: {
        type: [
          { required: true, message: '请选择大类', trigger: 'blur' }
        ],
        exhibitionId: [
          { required: true, message: '请选择展会', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '请选择icon', trigger: 'blur' }
        ],
      },
      exhList:[],
      typeSelect:[{"name":"服务类","value":"1"},
        {"name":"工程类","value":"2"},
        {"name":"餐饮类","value":"3"},
        {"name":"租赁类","value":"4"}],
    }
  },
  mounted() {
    this.tableList();
  },
  methods:{
    tableList(){
      this.loading = true;
      qryExhibitionList({pageSize:1000}).then(res => {
        this.exhList = res.data.list;
        if (this.editableTabsValue == 0){
          this.editableTabsValue=res.data.list[0].id
        }
        this.formInline.exhibitionId = this.editableTabsValue
        qryCommodityList(this.formInline).then(res => {
          this.listData = res.data.list;
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.pageSize;
          this.pageparm.total = res.data.total;
          this.loading = false
        })
      })

    },


    turn(row) {
      var data={
        id:row.id,
        status:row.status
      }
      upCommodityStatus(data).then(res =>{
        if (res.code==1) {
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      }).catch(err => {
        this.$message.error('保存失败，请稍后再试！')
      })
    },

    upClass1(img){
      document.getElementById('upClass1').className='imgdiv on'
      document.getElementById('upClass2').className='imgdiv'
      document.getElementById('upClass3').className='imgdiv'
      document.getElementById('upClass4').className='imgdiv'
      document.getElementById('upClass5').className='imgdiv'
      document.getElementById('upClass6').className='imgdiv'
      document.getElementById('upClass7').className='imgdiv'
      document.getElementById('upClass8').className='imgdiv'
      document.getElementById('upClass9').className='imgdiv'
      this.editForm.icon =img
    },
    upClass2(img){
      document.getElementById('upClass2').className='imgdiv on'
      document.getElementById('upClass1').className='imgdiv'
      document.getElementById('upClass3').className='imgdiv'
      document.getElementById('upClass4').className='imgdiv'
      document.getElementById('upClass5').className='imgdiv'
      document.getElementById('upClass6').className='imgdiv'
      document.getElementById('upClass7').className='imgdiv'
      document.getElementById('upClass8').className='imgdiv'
      document.getElementById('upClass9').className='imgdiv'
      this.editForm.icon =img
    },
    upClass3(img){
      document.getElementById('upClass3').className='imgdiv on'
      document.getElementById('upClass1').className='imgdiv'
      document.getElementById('upClass2').className='imgdiv'
      document.getElementById('upClass4').className='imgdiv'
      document.getElementById('upClass5').className='imgdiv'
      document.getElementById('upClass6').className='imgdiv'
      document.getElementById('upClass7').className='imgdiv'
      document.getElementById('upClass8').className='imgdiv'
      document.getElementById('upClass9').className='imgdiv'
      this.editForm.icon =img
    },
    upClass4(img){
      document.getElementById('upClass3').className='imgdiv'
      document.getElementById('upClass1').className='imgdiv'
      document.getElementById('upClass2').className='imgdiv'
      document.getElementById('upClass4').className='imgdiv on'
      document.getElementById('upClass5').className='imgdiv'
      document.getElementById('upClass6').className='imgdiv'
      document.getElementById('upClass7').className='imgdiv'
      document.getElementById('upClass8').className='imgdiv'
      document.getElementById('upClass9').className='imgdiv'
      this.editForm.icon =img
    },
    upClass5(img){
      document.getElementById('upClass3').className='imgdiv'
      document.getElementById('upClass1').className='imgdiv'
      document.getElementById('upClass2').className='imgdiv'
      document.getElementById('upClass4').className='imgdiv'
      document.getElementById('upClass5').className='imgdiv on'
      document.getElementById('upClass6').className='imgdiv'
      document.getElementById('upClass7').className='imgdiv'
      document.getElementById('upClass8').className='imgdiv'
      document.getElementById('upClass9').className='imgdiv'
      this.editForm.icon =img
    },
    upClass6(img){
      document.getElementById('upClass3').className='imgdiv'
      document.getElementById('upClass1').className='imgdiv'
      document.getElementById('upClass2').className='imgdiv'
      document.getElementById('upClass4').className='imgdiv'
      document.getElementById('upClass5').className='imgdiv'
      document.getElementById('upClass6').className='imgdiv on'
      document.getElementById('upClass7').className='imgdiv'
      document.getElementById('upClass8').className='imgdiv'
      document.getElementById('upClass9').className='imgdiv'
      this.editForm.icon =img
    },
    upClass7(img){
      document.getElementById('upClass3').className='imgdiv'
      document.getElementById('upClass1').className='imgdiv'
      document.getElementById('upClass2').className='imgdiv'
      document.getElementById('upClass4').className='imgdiv'
      document.getElementById('upClass5').className='imgdiv'
      document.getElementById('upClass6').className='imgdiv'
      document.getElementById('upClass7').className='imgdiv on'
      document.getElementById('upClass8').className='imgdiv'
      document.getElementById('upClass9').className='imgdiv'
      this.editForm.icon =img
    },
    upClass8(img){
      document.getElementById('upClass3').className='imgdiv'
      document.getElementById('upClass1').className='imgdiv'
      document.getElementById('upClass2').className='imgdiv'
      document.getElementById('upClass4').className='imgdiv'
      document.getElementById('upClass5').className='imgdiv'
      document.getElementById('upClass6').className='imgdiv'
      document.getElementById('upClass7').className='imgdiv'
      document.getElementById('upClass8').className='imgdiv on'
      document.getElementById('upClass9').className='imgdiv'
      this.editForm.icon =img
    },
    upClass9(img){
      document.getElementById('upClass3').className='imgdiv'
      document.getElementById('upClass1').className='imgdiv'
      document.getElementById('upClass2').className='imgdiv'
      document.getElementById('upClass4').className='imgdiv'
      document.getElementById('upClass5').className='imgdiv'
      document.getElementById('upClass6').className='imgdiv'
      document.getElementById('upClass7').className='imgdiv'
      document.getElementById('upClass8').className='imgdiv'
      document.getElementById('upClass9').className='imgdiv on'
      this.editForm.icon =img
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.name = row.name
        this.editForm.icon = row.icon
        this.editForm.type = row.type.toString()
        this.editForm.exhibitionId = row.exhibitionId
        this.editForm.sort = row.sort
        // 日期回显
      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.name = '';
        this.editForm.icon = '';
        this.editForm.type = '';
        this.editForm.exhibitionId = '';
        this.editForm.sort = '';
      }
    },
    closeDialog(editData){
      this.$refs['editForm'].resetFields();
      this.baseForm = [];
      this.editFormVisible = false;
    },
    handleAvatarSuccessImage(res) {
      this.editForm.icon = res.data;
    },
    beforeAvatarUpload(file) {
      //const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      /*if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }*/
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },


    // 编辑、添加提交方法
    submitForm(editData) {
      this.isDisabled = true;
      console.log("this.editForm",this.editForm)
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id!=''){
            upCommodity(this.editForm).then(res =>{
              if (res.code==1) {
                this.editFormVisible = false
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.editFormVisible = false
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }
          else{
            addCommodity(this.editForm)
              .then(res => {
                if (res.code==1) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.tableList(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
                this.isDisabled = false;
              })
              .catch(err => {
                this.editFormVisible = false
                this.$message.error('保存失败，请稍后再试！')
                this.isDisabled = false;
              })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },

    deleteData(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          delBanner({id:row.id})
            .then(res => {
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '数据已删除!'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },

    //根据表头显示数据
    tablesListByExhId(){
      this.loading = true;
      this.formInline.exhibitionId = this.editableTabsValue;
      qryCommodityList(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })
    },

    resetFrom(){
      this.formInline.name = '';
      this.formInline.status = '';
      this.formInline.type = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
      this.tableList();
    },



  },
  //分页组件
  components: {
    ElInputNumber,
    Pagination
  }
}



</script>



<style scoped>

.iconlist{
  display: flex;
  flex-wrap: wrap;
}
.iconlist .imgdiv{
  width: 60px;
  height: 60px;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.iconlist .imgdiv.on{
  border: 2px #000000 solid;
}
.iconlist .imgdiv .img{
  width: 60px;
  height: 60px;
}
.tiphint{
  font-size: 12px;
  color: #606266;
  margin-top: 7px
}
</style>



// WEBPACK FOOTER //
// src/views/lottery/playgroundList.vue